module.exports = __webpack_public_path__ + "assets/img/featured-1.9c2ac507.jpg";